import { render, staticRenderFns } from "./VoicemailPreview.vue?vue&type=template&id=1a880660&"
import script from "./VoicemailPreview.vue?vue&type=script&lang=js&"
export * from "./VoicemailPreview.vue?vue&type=script&lang=js&"
import style0 from "./VoicemailPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports